import layout from '@/layout'

export default {
  path: '/tools',
  component: layout,
  redirect: '/tools/goods',
  name: 'tools_maps',
  meta: {
    title: '工具',
    icon: 'tools'
  },
  children: [
    {
      path: '/tools/map',
      name: 'tools_map',
      component: () => import('@/views/tools/map/index.vue'),
      meta: {
        title: '地图',
        icon: 'map'
      }
    }
  ]
}
